import { Configuration, getConfiguration } from '../internal';

let config: Configuration | null = null;
let url = '';

export const signout = async () => {
  if (!config) {
    config = await getConfiguration();
    const contextPath = config.get('contextPath');
    if (contextPath) {
      url = `${contextPath}/logout`;
    }
  }

  if (url) {
    window.location.assign(url);
  }
};
